/**
 * ANTLR4 ES Module Interop
 *
 * This module provides a clean interface to antlr4 while handling
 * the CommonJS to ES Module conversion internally.
 */

import * as antlr4Module from 'antlr4';

// When imported as ES module, the classes are directly on antlr4Module
// The module exports all classes at the top level
const antlr4: any = antlr4Module;

// Re-export commonly used classes for direct imports
export const InputStream = antlr4.InputStream;
export const CommonTokenStream = antlr4.CommonTokenStream;
export const ParseTreeVisitor = antlr4.ParseTreeVisitor;
export const Lexer = antlr4.Lexer;
export const Parser = antlr4.Parser;
export const ParserRuleContext = antlr4.ParserRuleContext;
export const ErrorListener = antlr4.ErrorListener;

// Re-export additional classes needed by generated parsers
export const ATNDeserializer = antlr4.ATNDeserializer;
export const DFA = antlr4.DFA;
export const PredictionContextCache = antlr4.PredictionContextCache;
export const ParserATNSimulator = antlr4.ParserATNSimulator;
export const LexerATNSimulator = antlr4.LexerATNSimulator;

// Export the full antlr4 module as default
// Type as 'any' to avoid TypeScript issues with dynamic properties
export default antlr4 as any;
